import { render } from "./LeftMenu.vue?vue&type=template&id=4be3e501"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/aws.dot-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__